import { ContainerV1Properties } from '@adobe/aem-core-components-react-spa'

export interface ReactModalProps extends ContainerV1Properties {
  modal: string
  modalId: string
}

export interface ContainerProps {
  className?: string
}

export enum AemModalTypes {
  basicModal = 'basicModal'
}
